import { NgModule } from '@angular/core';
import { CommonModule, TitleCasePipe } from '@angular/common';
import { BytesToSizePipe } from './pipes/bytes-to-size.pipe';
import { B64Pipe } from './pipes/b64.pipe';
import { LimitToPipe } from './pipes/limit-to.pipe';
import { StartFromPipe } from './pipes/start-from.pipe';
import { OrderByPipe } from './pipes/order-by.pipe';
import { UcFirstPipe } from './pipes/uc-first.pipe';
import { RootLayoutComponent } from './layout/root-layout/root-layout.component';
import { UserPanelComponent } from './layout/user-panel/user-panel.component';
import { SettingsNavLayoutComponent } from './layout/settings-nav-layout/settings-nav-layout.component';
import { ComponentsModule } from '@material-library';
import { MatCardModule } from '@angular/material/card';
import { RouterModule } from '@angular/router';
import { NotificationsModule } from '../notifications/notifications.module';
import { ErrorComponent } from './components/error/error.component';
import { GlobalMessageComponent } from './layout/global-message/global-message.component';
import { DialogConfirmPasswordComponent } from './components/dialog-confirm-password/dialog-confirm-password.component';
import { HelpDialogComponent } from './layout/root-layout/help-dialog/help-dialog.component';
import { DialogShareNewComponent } from './components/dialog-share-new/dialog-share-new.component';
import { ShareMemberAddComponent } from './components/share-member-add/share-member-add.component';
import { ShareMemberListComponent } from './components/dialog-share-details/share-member-list/share-member-list.component';
import { DialogShareDetailsComponent } from './components/dialog-share-details/dialog-share-details.component';
import { ShareOptionsComponent } from './components/dialog-share-details/share-options/share-options.component';
import { ShareDeleteComponent } from './components/dialog-share-details/share-delete/share-delete.component';
import { SharePermissionComponent } from './components/dialog-share-details/share-permission/share-permission.component';
import { ShareMemberRemoveComponent } from './components/dialog-share-details/share-member-remove/share-member-remove.component';
import { ShareChooseOwnerComponent } from './components/dialog-share-details/share-choose-owner/share-choose-owner.component';
import { ShareMemberInviteComponent } from './components/dialog-share-details/share-member-invite/share-member-invite.component';
import { VerifyEmailRequiredComponent } from './components/verify-email-required/verify-email-required.component';
import { ShareLeaveComponent } from './components/dialog-share-details/share-leave/share-leave.component';
import { RoundProgressModule } from 'angular-svg-round-progressbar';
import { TranslateTransferItemPipe } from './pipes/translate-transfer-item.pipe';
import { UploadDropBoxDirective } from './directives/upload-drop-box.directive';
import { CopyLinkDirective } from './Directives/copy-link.directive';
import { SaveFileComponent } from './components/save-file/save-file.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DialogLinkComponent } from './components/dialog-link/dialog-link.component';
import { LinkCreateComponent } from './components/dialog-link/link-create/link-create.component';
import { LinkDeleteComponent } from './components/dialog-link/link-delete/link-delete.component';
import { LinkManageComponent } from './components/dialog-link/link-manage/link-manage.component';
import { LinkSettingsComponent } from './components/dialog-link/link-settings/link-settings.component';
import { LinkShareComponent } from './components/dialog-link/link-share/link-share.component';
import { MoveConflictsComponent } from '../file-list/actions/move-dialog/move-conflicts/move-conflicts.component';
import { MoveDialogComponent } from '../file-list/actions/move-dialog/move-dialog.component';
import { MoveNewFolderComponent } from '../file-list/actions/move-dialog/move-new-folder/move-new-folder.component';
import { MoveSelectDestinationDirComponent } from '../file-list/actions/move-dialog/move-select-destination-dir/move-select-destination-dir.component';
import { MoveTransferComponent } from '../file-list/actions/move-dialog/move-transfer/move-transfer.component';
import { DialogDeleteComponent } from '../file-list/dialog-delete/dialog-delete.component';
import { DialogRenameComponent } from '../file-list/dialog-rename/dialog-rename.component';
import { DialogNewFolderComponent } from '../file-list/dialog-new-folder/dialog-new-folder.component';
import { LinksLayoutComponent } from './layout/links-layout/links-layout.component';
import { CommentBlockComponent } from './components/comment/comment-block/comment-block.component';
import { CommentComponent } from './components/comment/comment/comment.component';
import { ReplyComponent } from './components/comment/reply/reply.component';
import { CommentCpIFrameComponent } from './components/comment/comment-cp-service/comment-cp-iframe.component';
import { SharesNavLayoutComponent } from './layout/shares-nav-layout/shares-nav-layout.component';
import { UploadFilesComponent } from './components/upload-files/upload-files.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UpgradePlanButtonComponent } from './components/upgrade-plan-button/upgrade-plan-button.component';

import { LinkPermissionsFormComponent } from './components/dialog-link/link-permissions-form/link-permissions-form.component';
import { RelativeTimePipe } from './pipes/relative-time.pipe';
import { CommentInputComponent } from './components/comment/comment-input/comment-input.component';
import { UploadPublicDropBoxDirective } from './directives/upload-public-drop-box.directive';
import { LayoutComponent } from './layout/layout/layout.component';
import { PasswordFieldsComponent } from './components/password-fields/password-fields.component';
import { ComplexPasswordComponent } from './components/complex-password/complex-password.component';
import { ProcessPillComponent } from './components/process-pill/process-pill.component';
import { DialogErrorComponent } from './components/dialog-error/dialog-error.component';
import { SecuredTooltipComponent } from './components/secured-tooltip/secured-tooltip.component';
import { OptOutComponent } from '../opt-out/opt-out.component';
import { NotFoundComponent } from '../pages/not-found/not-found.component';

import { ReportLinkDialogComponent } from './layout/root-layout/report-link-dialog/report-link-dialog.component';
import { A11yModule } from '@angular/cdk/a11y';
import { LinkInfoDialogComponent } from './components/dialog-link/link-info-dialog/link-info-dialog.component';
import { PaymentSuccessComponent } from '../payment-success/payment-success.component';
import { PayInvoiceComponent } from '../pay-invoice/pay-invoice.component';
import { HelpSignInDialogComponent } from './layout/root-layout/help-sign-in-dialog/help-sign-in-dialog.component';
import { HelpLinkDialogComponent } from './layout/root-layout/help-link-dialog/help-link-dialog.component';
import { TransferComponent } from './components/transfer/transfer.component'

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    MatCardModule,
    RouterModule,
    NotificationsModule,
    RoundProgressModule,
    MatTooltipModule,
    ReactiveFormsModule,
    FormsModule,
    A11yModule
  ],
  declarations: [
    BytesToSizePipe,
    B64Pipe,
    LimitToPipe,
    StartFromPipe,
    OrderByPipe,
    UcFirstPipe,
    RootLayoutComponent,
    UserPanelComponent,
    SettingsNavLayoutComponent,
    ErrorComponent,
    GlobalMessageComponent,
    DialogConfirmPasswordComponent,
    HelpDialogComponent,
    DialogShareNewComponent,
    ShareMemberAddComponent,
    ShareMemberListComponent,
    DialogShareDetailsComponent,
    ShareOptionsComponent,
    ShareDeleteComponent,
    SharePermissionComponent,
    ShareMemberRemoveComponent,
    ShareChooseOwnerComponent,
    ShareMemberInviteComponent,
    VerifyEmailRequiredComponent,
    ShareLeaveComponent,
    TransferComponent,
    TranslateTransferItemPipe,
    UploadDropBoxDirective,
    UploadPublicDropBoxDirective,
    CopyLinkDirective,
    SaveFileComponent,
    UpgradePlanButtonComponent,
    DialogRenameComponent,
    DialogLinkComponent,
    LinkCreateComponent,
    LinkDeleteComponent,
    LinkManageComponent,
    LinkSettingsComponent,
    LinkShareComponent,
    MoveDialogComponent,
    MoveSelectDestinationDirComponent,
    MoveConflictsComponent,
    MoveTransferComponent,
    MoveNewFolderComponent,
    DialogDeleteComponent,
    DialogNewFolderComponent,

    LinksLayoutComponent,
    CommentBlockComponent,
    CommentComponent,
    ReplyComponent,
    CommentCpIFrameComponent,
    UploadFilesComponent,
    LinkPermissionsFormComponent,
    RelativeTimePipe,
    CommentInputComponent,
    ReportLinkDialogComponent,
    SharesNavLayoutComponent,
    LayoutComponent,
    PasswordFieldsComponent,
    ComplexPasswordComponent,
    ProcessPillComponent,
    DialogErrorComponent,
    SecuredTooltipComponent,
    OptOutComponent,
    NotFoundComponent,
    LinkInfoDialogComponent,
    PaymentSuccessComponent,
    PayInvoiceComponent,
    HelpSignInDialogComponent,
    HelpLinkDialogComponent,
  ],
  exports: [
    BytesToSizePipe,
    B64Pipe,
    LimitToPipe,
    StartFromPipe,
    OrderByPipe,
    UcFirstPipe,
    RootLayoutComponent,
    UserPanelComponent,
    SettingsNavLayoutComponent,
    ErrorComponent,
    GlobalMessageComponent,
    DialogConfirmPasswordComponent,
    DialogShareNewComponent,
    ShareMemberAddComponent,
    DialogShareDetailsComponent,
    TranslateTransferItemPipe,
    CopyLinkDirective,
    MatTooltipModule,
    UploadDropBoxDirective,
    UploadPublicDropBoxDirective,
    DialogRenameComponent,
    DialogLinkComponent,
    LinkCreateComponent,
    LinkDeleteComponent,
    LinkManageComponent,
    LinkSettingsComponent,
    LinkShareComponent,
    MoveDialogComponent,
    VerifyEmailRequiredComponent,
    MoveSelectDestinationDirComponent,
    MoveConflictsComponent,
    MoveTransferComponent,
    MoveNewFolderComponent,
    DialogDeleteComponent,
    DialogNewFolderComponent,
    CommentBlockComponent,
    CommentComponent,
    ReplyComponent,
    CommentCpIFrameComponent,
    UploadFilesComponent,
    RelativeTimePipe,
    LayoutComponent,
    PasswordFieldsComponent,
    UploadFilesComponent,
    UpgradePlanButtonComponent,
    TransferComponent,
    HelpDialogComponent,
    ComplexPasswordComponent,
    LinkInfoDialogComponent,
    HelpLinkDialogComponent
  ],
  providers: [
    B64Pipe,OrderByPipe,TitleCasePipe, RelativeTimePipe
  ]
})
export class SharedModule { }
